// import topGraphPanel from '../FluVaccinationDetails/TopGraphPanel'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import RareDiseaseDetails from './RarediseaseDetails'
const index = () => {
  return   (
    <Layout>
      <Content>
       <RareDiseaseDetails />
      
      </Content>
    </Layout>
  )
    
  
}

export default index
